var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow-sm",attrs:{"id":"container"}},[_c('router-link',{attrs:{"to":_vm.mapUrl}},[_c('img',{staticClass:"mapBanner",attrs:{"src":_vm.mapBannerUrl}})]),_c('div',{staticClass:"mapTitle"},[_vm._v(_vm._s(_vm.name))]),_c('router-link',{attrs:{"to":_vm.mapUrl}},[_vm._v(_vm._s(_vm.$t("admin.maps.open")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }